import { FC } from 'react'
import {
  BooleanInput, Edit, NumberInput, SelectInput, SimpleForm, TextInput,
  required, useTranslate,
} from 'react-admin'
import { Typography } from '@mui/material'
import { AUTH_TYPE_CHOICES } from './headerConstants'

const ApplicationEdit: FC = () => {
  const translate = useTranslate()

  return (
    <Edit mutationMode="pessimistic">
      <SimpleForm>
        <TextInput source="display_name" label="data.displayName" fullWidth validate={required()} />
        <TextInput source="description" label="data.description" fullWidth multiline />
        <SelectInput
          source="auth_type"
          label="data.authType"
          fullWidth
          validate={required()}
          choices={AUTH_TYPE_CHOICES}
        />
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {translate('data.environmentAuthHelp')}
        </Typography>
        <NumberInput
          source="cost_per_1000_calls"
          label="data.costPer1000Calls"
          min={0}
          step={0.001}
          fullWidth
        />
        <BooleanInput source="enabled" label="data.enabled" />
      </SimpleForm>
    </Edit>
  )
}

export default ApplicationEdit
